<template>
  <p :class="[ 'message', severity ]"
     v-if="message || $slots.default">
    <slot>
      {{ message }}
    </slot>
  </p>
</template>

<script>
export default {
  props: {
    message: { type: String, default: '' },
    severity: { type: String, default: 'information' },
  },
};
</script>

<style scoped>
.message {
  padding: 10px;
  border-radius: 5px;
}

.message.information {
  background-color: rgba(66,139,202,0.2);
  border: 1px solid #428bca;
}

.message.warning {
  background: rgba(255,68,17,0.2);
  border: 1px solid #ff4411;
}
</style>



// WEBPACK FOOTER //
// src/components/elements/FormMessage.vue